import { render, staticRenderFns } from "./HoldingsTable.vue?vue&type=template&id=425dcd94&"
import script from "./HoldingsTable.vue?vue&type=script&lang=js&"
export * from "./HoldingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports